import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, Typography, Grid, Button, TextField, InputAdornment , IconButton, Stack, ThemeProvider, FormControlLabel, Checkbox, Autocomplete } from '@mui/material';
import config from 'src/config';
import Iconify from 'src/components/iconify';
import { useNavigate } from 'react-router-dom';
import { createTheme } from '@mui/material/styles'
import { AuthHeader } from 'src/components/auth/header';
import { AuthFooter } from 'src/components/auth/footer';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { register } from 'src/services/auth.service';
import countries from 'src/assets/countries/countries.json';

const theme = createTheme({
    palette: {
      primary: {
        main: '#ff9933'
      }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                    textTransform: 'none'
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderRadius: '8px',
                        },
                    },
                },
            },
        },
    }
});

class BusinessRegisterPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            show_password: false,
            show_confirm_password: false,
            current_step: 'step1',
            countries: countries,

            pristine: {
                name: true,
                username: true,
                password: true,
                confirm_password: true,
                company_name: true,
                country: true,
                company_website: true,
                company_registration_number: true,
                designation: true,
                linkedin_profile_url: true,
                company_address: true
            },

            authorized_to_create: false,
            agree_to_terms: false,
            registering: false,

            // payload
            // step - 1
            account_type: 'business',
            name: '',
            username: '',
            password: '',
            confirm_password: '',
            // step - 2
            company_name: '',
            country: '',
            company_website: '',
            company_registration_number: '',
            designation: '',
            linkedin_profile_url: '',
            company_address: ''
        }

    }

    validateName(name, checkPristine = true) {

        if (checkPristine && this.state.pristine.name) {
            return true;
        }

        if (!name.trim()) {
            return false;
        }

        return true;
    }

    validateUsername(username, checkPristine = true) {

        if (checkPristine && this.state.pristine.username) {
            return true;
        }

        if (!username) {
            return false;
        }

        if (username.indexOf('@') === -1) {
            return false;
        }

        if (username.indexOf('.') === -1) {
            return false;
        }

        return true;
    }

    validatePassword(password, checkPristine = true) {

        if (checkPristine && this.state.pristine.password) {
            return true;
        }

        if (!password) {
            return false;
        }

        if (password.length < 12) {
            return false;
        }

        return true;
    }

    validateConfirmPassword(confirm_password, checkPristine = true) {
        if (checkPristine && this.state.pristine.confirm_password) {
            return true;
        }

        if (!confirm_password) {
            return false;
        }

        if (confirm_password !== this.state.password) {
            return false;
        }

        return true;
    }

    validateCompanyName(company_name, checkPristine = true) {

        if (checkPristine && this.state.pristine.company_name) {
            return true;
        }

        if (!company_name.trim()) {
            return false;
        }

        return true;
    }

    validateCountry(country, checkPristine = true) {

        if (checkPristine && this.state.pristine.country) {
            return true;
        }

        if (!country.trim()) {
            return false;
        }

        return true;
    }

    validateCompanyWebsite(company_website, checkPristine = true) {

        if (checkPristine && this.state.pristine.company_website) {
            return true;
        }

        if (!company_website.trim()) {
            return false;
        }

        return true;
    }

    validateCompanyRegistrationNumber(company_registration_number, checkPristine = true) {

        if (checkPristine && this.state.pristine.company_registration_number) {
            return true;
        }

        if (!company_registration_number.trim()) {
            return false;
        }

        return true;
    }

    validateDesignation(designation, checkPristine = true) {

        if (checkPristine && this.state.pristine.designation) {
            return true;
        }

        if (!designation.trim()) {
            return false;
        }

        return true;
    }

    validateLinkedInProfileUrl(linkedin_profile_url, checkPristine = true) {

        if (checkPristine && this.state.pristine.linkedin_profile_url) {
            return true;
        }

        if (!linkedin_profile_url.trim()) {
            return false;
        }

        return true;
    }

    validateCompanyAddress(company_address, checkPristine = true) {

        if (checkPristine && this.state.pristine.company_address) {
            return true;
        }

        if (!company_address.trim()) {
            return false;
        }

        return true;
    }

    validateForm(step='both') {
        let valid = true;

        if (step === 'step1' || step === 'both') {
            valid = this.validateName(this.state.name, false) && this.validateUsername(this.state.username, false) && this.validatePassword(this.state.password, false) && this.validateConfirmPassword(this.state.confirm_password, false) && this.state.agree_to_terms;
        }

        if (step === 'step2' || step === 'both') {
            valid = valid && this.validateCompanyName(this.state.company_name, false) && this.validateCountry(this.state.country, false) && this.validateCompanyWebsite(this.state.company_website, false) && this.validateCompanyRegistrationNumber(this.state.company_registration_number, false) && this.validateDesignation(this.state.designation, false) && this.validateLinkedInProfileUrl(this.state.linkedin_profile_url, false) && this.validateCompanyAddress(this.state.company_address, false) && this.state.agree_to_terms && this.state.authorized_to_create;
        }

        return valid;
    }


    async handleRegister() {

        this.setState({ registering: true });

        let payload = {
            account_type: this.state.account_type,
            name: this.state.name,
            username: this.state.username,
            password: this.state.password,
            company_name: this.state.company_name,
            company_country: this.state.country,
            company_website: this.state.company_website,
            company_registration_number: this.state.company_registration_number,
            designation: this.state.designation,
            linkedin_profile_url: this.state.linkedin_profile_url,
            company_address: this.state.company_address,
        };

        let registerRes = await register(payload);
        if (registerRes.error) {
            this.setState({ registering: false });
            console.log(registerRes.error);
            alert('Error: ' + registerRes.error);
            return;
        }

        this.setState({ registering: false });

        if (registerRes.token) {
            this.props.navigate('/registersuccess?type=business');
        }
    }

    step1render() {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh', p: 2 }}>
                <Grid item xs={12} md={8} lg={4} xl={4}>


                    <AuthHeader
                        text={'Let\'s create your business account. This takes less than 3 minutes.'}
                    />

                    <Typography sx={{ fontWeight: 'bold', mt: 5 }}>
                        Full Name
                    </Typography>
                    <TextField
                        fullWidth
                        name="name"
                        size='small'
                        sx={{ mb: 2 }}
                        value={this.state.name}
                        onChange={(e) => {
                            this.setState({
                                name: e.target.value,
                                pristine: {
                                    ...this.state.pristine,
                                    name: false
                                }
                            });
                        }}
                        placeholder='John Doe'
                    />


                    <Typography sx={{ fontWeight: 'bold' }}>
                        Work Email
                    </Typography>
                    <TextField
                        fullWidth
                        name="email"
                        size='small'
                        sx={{ mb: 2 }}
                        value={this.state.username}
                        onChange={(e) => {
                            this.setState({
                                username: e.target.value,
                                pristine: {
                                    ...this.state.pristine,
                                    username: false
                                }
                            });
                        }}
                        placeholder='you@yourcompany.com'
                        error={!this.validateUsername(this.state.username)}
                        helperText={!this.validateUsername(this.state.username) ? 'Invalid email address' : ''}
                    />

                    <Typography sx={{ fontWeight: 'bold' }}>
                        Password
                    </Typography>
                    <TextField
                        fullWidth
                        name="password"
                        size='small'
                        placeholder='••••••••'
                        type={this.state.show_password ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => {
                                            this.setState({ show_password: !this.state.show_password });
                                        }}
                                        edge="end"
                                    >
                                        <Iconify icon={this.state.show_password ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        value={this.state.password}
                        onChange={(e) => {
                            this.setState({
                                password: e.target.value,
                                pristine: {
                                    ...this.state.pristine,
                                    password: false
                                }
                            });
                        }}
                        error={!this.validatePassword(this.state.password)}
                        helperText={!this.validatePassword(this.state.password) ? 'Password must be at least 12 characters' : 'Use at least 12 characters with a mix of uppercase, lowercase and numbers'}
                        FormHelperTextProps={{ sx: { m: 0 } }}
                    />

                    <Typography sx={{ fontWeight: 'bold', mt: 2 }}>
                        Confirm Password
                    </Typography>
                    <TextField
                        fullWidth
                        name="confirm_password"
                        size='small'
                        placeholder='••••••••'
                        type={this.state.show_confirm_password ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => {
                                            this.setState({ show_confirm_password: !this.state.show_confirm_password });
                                        }}
                                        edge="end"
                                    >
                                        <Iconify icon={this.state.show_confirm_password ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                        value={this.state.confirm_password}
                        onChange={(e) => {
                            this.setState({
                                confirm_password: e.target.value,
                                pristine: {
                                    ...this.state.pristine,
                                    confirm_password: false
                                }
                            });
                        }}
                        error={!this.validateConfirmPassword(this.state.confirm_password)}
                        helperText={!this.validateConfirmPassword(this.state.confirm_password) ? 'Password must match' : ''}
                    />

                    <Stack direction="row" sx={{ mb: 2 }} justifyContent={'space-between'}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.agree_to_terms}
                                    onChange={(e) => {
                                        this.setState({ agree_to_terms: e.target.checked });
                                    }}
                                    sx={{ color: 'gray' }}
                                />
                            }
                            label={
                                <Typography style={{ fontSize: '0.875rem', color: 'gray' }}>
                                    I agree to the {' '}
                                    <Link href="https://dmonk.ai/terms.html" underline="hover" target="_blank" rel="noopener noreferrer">
                                        Terms of Use
                                    </Link>
                                    {' '} and {' '}
                                    <Link href="https://dmonk.ai/privacyusers.html" underline="hover" target="_blank" rel="noopener noreferrer">
                                        Privacy Policy
                                    </Link>
                                </Typography>
                            }
                        />
                    </Stack>

                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        onClick={() => {
                            this.setState({ current_step: 'step2' });
                        }}
                        disabled={!this.validateForm('step1')}
                        style={{ color: 'white' }}
                        endIcon={<ArrowRightAltIcon />}
                    >
                        Continue to Company Details
                    </Button>

                    {/* Already have an account */}
                    <Stack direction="row" justifyContent="center" sx={{ mt: 2 }}>
                        <Typography variant="body2" sx={{ color: 'gray', mr: 1 }}>
                            Already registered? {' '}
                            <Link
                                underline="hover"
                                onClick={() => {
                                    this.props.navigate('/login');
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                Log In
                            </Link>
                        </Typography>
                    </Stack>

                    <AuthFooter />

                </Grid>
            </Grid>
        )
    }

    step2render() {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh', p: 2 }}>

                <Grid item xs={12}>
                    <AuthHeader
                        text={'Step 2 of 2 - Company Details'}
                    />
                </Grid>


                <Grid container xs={12} md={8} spacing={2}>

                    <Grid item xs={12} sx={{ mb: 4 }}>
                        <Typography style={{ fontSize: '0.875rem', color: 'gray', textAlign: 'center' }}>
                            Please provide your company details.<br />This helps us verify your request and support your setup.
                        </Typography>
                    </Grid>

                    {/* Go to step 1 */}
                    <Grid item xs={12}>
                        <IconButton
                            onClick={() => {
                                this.setState({ current_step: 'step1' });
                            }}
                            sx={{ padding: 0, fontSize: '0.875rem', color: 'gray' }}
                            // edge="end"
                        >
                            <ArrowBackIcon sx={{ mr: 1 }} />
                            Go back to Step 1
                        </IconButton>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Company Name
                        </Typography>
                        <TextField
                            fullWidth
                            name="company_name"
                            size='small'
                            sx={{ mb: 2 }}
                            value={this.state.company_name}
                            onChange={(e) => {
                                this.setState({
                                    company_name: e.target.value,
                                    pristine: {
                                        ...this.state.pristine,
                                        company_name: false
                                    }
                                });
                            }}
                            placeholder='Acme Inc.'
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Country
                        </Typography>
                        {/* Autocomplete with countries */}
                        <Autocomplete
                            options={this.state.countries}
                            getOptionLabel={(option) => `${option.emoji ? option.emoji + ' ' : ''}${option.name}`}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    fullWidth
                                    name="country"
                                    size='small'
                                    sx={{ mb: 2 }}
                                    placeholder='Select your country'
                                />
                            )}
                            onChange={(event, value) => {
                                this.setState({
                                    country: value ? value.name : '',
                                    pristine: {
                                        ...this.state.pristine,
                                        country: false
                                    }
                                });
                            }}
                        />

                        {/* <TextField
                            fullWidth
                            name="country"
                            size='small'
                            sx={{ mb: 2 }}
                            value={this.state.country}
                            onChange={(e) => {
                                this.setState({
                                    country: e.target.value,
                                    pristine: {
                                        ...this.state.pristine,
                                        country: false
                                    }
                                });
                            }}
                            placeholder='Denmark'
                        /> */}
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Company Website
                        </Typography>
                        <TextField
                            fullWidth
                            name="company_website"
                            size='small'
                            sx={{ mb: 2 }}
                            value={this.state.company_website}
                            onChange={(e) => {
                                this.setState({
                                    company_website: e.target.value,
                                    pristine: {
                                        ...this.state.pristine,
                                        company_website: false
                                    }
                                });
                            }}
                            placeholder='https://yourcompany.com'
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Registration Number
                        </Typography>
                        <TextField
                            fullWidth
                            name="company_registration_number"
                            size='small'
                            sx={{ mb: 2 }}
                            value={this.state.company_registration_number}
                            onChange={(e) => {
                                this.setState({
                                    company_registration_number: e.target.value,
                                    pristine: {
                                        ...this.state.pristine,
                                        company_registration_number: false
                                    }
                                });
                            }}
                            placeholder='eg. CVR, VAT or Tax ID'
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Your Role / Title
                        </Typography>
                        <TextField
                            fullWidth
                            name="designation"
                            size='small'
                            sx={{ mb: 2 }}
                            value={this.state.designation}
                            onChange={(e) => {
                                this.setState({
                                    designation: e.target.value,
                                    pristine: {
                                        ...this.state.pristine,
                                        designation: false
                                    }
                                });
                            }}
                            placeholder='Founder, Head of IT, etc.'
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            LinkedIn Profile URL
                        </Typography>
                        <TextField
                            fullWidth
                            name="linkedin_profile_url"
                            size='small'
                            sx={{ mb: 2 }}
                            value={this.state.linkedin_profile_url}
                            onChange={(e) => {
                                this.setState({
                                    linkedin_profile_url: e.target.value,
                                    pristine: {
                                        ...this.state.pristine,
                                        linkedin_profile_url: false
                                    }
                                });
                            }}
                            placeholder='https://www.linkedin.com/in/yourprofile'
                        />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Company Address
                        </Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            name="company_address"
                            size='small'
                            sx={{ mb: 2 }}
                            value={this.state.company_address}
                            onChange={(e) => {
                                this.setState({
                                    company_address: e.target.value,
                                    pristine: {
                                        ...this.state.pristine,
                                        company_address: false
                                    }
                                });
                            }}
                            placeholder='123 Business St, Business City, BC 12345'
                        />
                    </Grid>


                    <Grid item xs={12}>

                        <Stack direction="column" sx={{ mb: 2, mt: 2 }} justifyContent={'space-between'}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.authorized_to_create}
                                        onChange={(e) => {
                                            this.setState({ authorized_to_create: e.target.checked });
                                        }}
                                        sx={{ color: 'gray' }}
                                    />
                                }
                                label={
                                    <Typography style={{ fontSize: '0.875rem', color: 'gray' }}>
                                        I confirm that I am authorized to create a business account on behalf of my company.
                                    </Typography>
                                }
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.agree_to_terms}
                                        onChange={(e) => {
                                            this.setState({ agree_to_terms: e.target.checked });
                                        }}
                                        sx={{ color: 'gray' }}
                                    />
                                }
                                label={
                                    <Typography style={{ fontSize: '0.875rem', color: 'gray' }}>
                                        I agree to the {' '}
                                        <Link href="https://dmonk.ai/terms.html" underline="hover" target="_blank" rel="noopener noreferrer">
                                            Terms of Use
                                        </Link>
                                        {' '} and {' '}
                                        <Link href="https://dmonk.ai/privacyusers.html" underline="hover" target="_blank" rel="noopener noreferrer">
                                            Privacy Policy
                                        </Link>
                                    </Typography>
                                }
                            />
                        </Stack>
                    </Grid>


                    <Grid item xs={12}>

                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            onClick={this.handleRegister.bind(this)}
                            disabled={!this.validateForm() || this.state.registering}
                            style={{ color: 'white' }}
                        >
                            {this.state.registering ? 'Signing Up...' : 'Complete Signup'}
                        </Button>

                    </Grid>

                </Grid>

                <Grid item xs={12}>
                    <AuthFooter />
                </Grid>

            </Grid>
        )
    }

    render() {

        console.log(this.state.countries);

        return (
            <ThemeProvider theme={theme}>
                <Helmet>
                    <title> Business User Register | {config.APP_NAME} </title>
                </Helmet>


                {(this.state.current_step === 'step1') ? this.step1render() : null}

                {(this.state.current_step === 'step2') ? this.step2render() : null}

            </ThemeProvider>
        )
    }
}

export default function (props) {
    const navigate = useNavigate();

    return <BusinessRegisterPage {...props} navigate={navigate} />;
}

